export enum ModuleConfigColumn {
  Status = 'status',
  Name = 'name',
  NextRunTime = 'nextRunTime',
  RunWeekly = 'runWeekly',
  ScanIntervalInWeeks = 'scanIntervalInWeeks',
  Internal = 'internal',
  External = 'external',
  Website = 'website',
  Darknet = 'darknet',
  Actions = 'actions',
}

export namespace ModuleConfigColumn {
  export const allColumns: string[] = [
    ModuleConfigColumn.Status,
    ModuleConfigColumn.Name,
    ModuleConfigColumn.NextRunTime,
    ModuleConfigColumn.RunWeekly,
    ModuleConfigColumn.ScanIntervalInWeeks,
    ModuleConfigColumn.Internal,
    ModuleConfigColumn.External,
    ModuleConfigColumn.Website,
    ModuleConfigColumn.Darknet,
    ModuleConfigColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    ModuleConfigColumn.Status,
    ModuleConfigColumn.Name,
    ModuleConfigColumn.NextRunTime,
    ModuleConfigColumn.ScanIntervalInWeeks,
    ModuleConfigColumn.RunWeekly,
    ModuleConfigColumn.Internal,
    ModuleConfigColumn.External,
    ModuleConfigColumn.Website,
    ModuleConfigColumn.Darknet,
    ModuleConfigColumn.Actions,
  ];

  export const translateKey = (column: string) => {
    switch (column) {
      case ModuleConfigColumn.Status:
        return 'moduleConfigurations.scanConfigs.status';
      case ModuleConfigColumn.Name:
        return 'moduleConfigurations.scanConfigs.name';
      case ModuleConfigColumn.NextRunTime:
        return 'moduleConfigurations.scanConfigs.nextRunTime';
      case ModuleConfigColumn.RunWeekly:
        return 'moduleConfigurations.scanConfigs.runWeekly';
      case ModuleConfigColumn.ScanIntervalInWeeks:
        return 'moduleConfigurations.scanConfigs.scanIntervalInWeeks';
      case ModuleConfigColumn.Internal:
        return 'moduleConfigurations.scanConfigs.internalScan';
      case ModuleConfigColumn.External:
        return 'moduleConfigurations.scanConfigs.externalScan';
      case ModuleConfigColumn.Website:
        return 'moduleConfigurations.scanConfigs.websiteScan';
      case ModuleConfigColumn.Darknet:
        return 'moduleConfigurations.scanConfigs.darknetScan';
      case ModuleConfigColumn.Actions:
        return 'moduleConfigurations.scanConfigs.actions';
      default:
        return '';
    }
  };

  export const sortField = (column: string) => {
    switch (column) {
      case ModuleConfigColumn.Name:
        return 'name';
      case ModuleConfigColumn.NextRunTime:
        return 'nextRunTime';
      case ModuleConfigColumn.RunWeekly:
        return 'runWeekly';
      case ModuleConfigColumn.Status:
        return 'status';
      case ModuleConfigColumn.ScanIntervalInWeeks:
        return 'scanIntervalInWeeks';
      case ModuleConfigColumn.Internal:
        return 'internal';
      case ModuleConfigColumn.External:
        return 'external';
      case ModuleConfigColumn.Website:
        return 'website';
      case ModuleConfigColumn.Darknet:
        return 'darknet';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
